<template>
  <v-container grid-list-xl class="pa-0 pt-6">
    <v-row wrap>
      <v-col cols="12">
        <m-alert type="info" show :info="'Anda berada pada program Diklat GTK <strong>' + current_instansi.nama + '</strong>. '">
          <template v-slot:default>
            <span class="black--text">Ingin Beralih</span>
            <m-button class="mt-n1 mx-0" text textButton="ke Seri Lain?" action="toDashboard" @toDashboard="toDashboard()"></m-button>
          </template>
        </m-alert>
        <m-card-list
          title="Daftar Pengelola"
          search
          id-key
          :add="isCan('kelas-enrol') && current_user.is_super_admin"
          addText="Pengguna"
          addHint="Tambah Pengguna"
          filter
          refresh
          :variablePencarian="[
            { key: 'Nama', value: 'nama' },
            { key: 'Surel', value: 'surel' }
          ]"
          @refresh="load"
          :items="items"
          footerLabel="Pengguna"
          @search="
            search => {
              dataPencarian = search;
              load();
            }
          "
          :page="page"
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
          @add="add"
          footer
        >
          <template v-slot:items="{ item }">
            <v-row class="mx-3 my-2">
              <v-col v-for="(content, i) in grid" :key="i" v-bind="content.grid" class="d-sm-flex" :align="content.align" :justify="content.justify">
                <template v-if="content.type == 'icon'">
                  <v-avatar v-bind="content.avatar">
                    <v-icon v-if="content.icon" class="secondary--text">{{ content.icon }}</v-icon>
                    <v-img v-else-if="content.src" :src="content.src"></v-img>
                  </v-avatar>
                </template>
                <template v-else-if="content.type == 'multi'">
                  <v-row>
                    <v-col v-for="(conts, index) in content.contents" :key="index" v-bind="conts.grid">
                      <p v-for="cont in conts.content" :key="cont.name" :class="cont.class">{{ cont.label ? cont.label : wrapObj(cont.name, item) }}</p>
                      <template v-if="conts.custom">
                        <p v-for="peran in item.peran" :key="peran.id" :class="$user.statusColor(peran.id) + `--text font-weight-bold`">
                          {{ pVal(peran, "keterangan") | toTitleCase }}
                        </p>
                      </template>
                      <template v-if="conts.customWilayah">
                        <p v-for="bgp in item.bgp" :key="bgp.id" :class="$user.statusColor(2) + `--text font-weight-medium py-0`">
                          BBGP {{ pVal(bgp, "keterangan") | toTitleCase }}
                        </p>
                      </template>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
              <!-- <v-col cols="1" sm="1" md="1" lg="1" xl="1">
                <p class="caption black--text my-0 py-0">Aksi</p>
                <m-menu left style="float:right" :items="more_menu" :object="item" />
              </v-col> -->
            </v-row>
            <v-divider />
          </template>
        </m-card-list>
      </v-col>
      <ChangeDlg ref="dlg" />
    </v-row>
  </v-container>
</template>

<script>
import { ALERT_INFO } from "@/const";
import ChangeDlg from "../../user/components/FormPengguna.vue";

export default {
  components: {
    ChangeDlg
    // DetailDlg
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      itemMapels: [],
      peran: null,
      textSearch: null,
      dataPencarian: null,
      page: null,
      cp: 1,
      more_menu: [
        {
          title: "Set Admin",
          click: (i, o) => this.setRole(o)
        }
      ]
    };
  },
  computed: {
    grid() {
      const conf = [
        {
          grid: { cols: 2, sm: 2, md: 1, lg: 1, xl: 1 },
          type: "icon",
          justify: "center",
          align: "center",
          src:
            this.items.kelamin == null
              ? "https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-laki.png"
              : this.items.kelamin == "L"
              ? "https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-laki.png"
              : "https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-perempuan.png",
          avatar: {
            size: 60,
            color: "white"
          }
        },
        {
          grid: { cols: this.$vuetify.breakpoint.smAndUp ? 12 : 10, sm: 9, md: 9, lg: 10, xl: 10 },
          type: "multi",
          contents: [
            {
              grid: { cols: 12, sm: 12, md: 5, lg: 5, xl: 5 },
              content: [
                {
                  label: "Nama",
                  class: "caption black--text my-0 py-0"
                },
                {
                  name: "name",
                  class: "font-weight-bold my-0 py-0"
                },
                {
                  name: "email",
                  class: "blue--text caption"
                },
                {
                  label: "Komunitas",
                  class: "caption black--text my-0 py-0"
                },
                {
                  name: "komunitas",
                  class: "black--text caption"
                }
              ]
            },
            {
              grid: { cols: 12, sm: 12, md: 3, lg: 3, xl: 3 },
              content: [
                {
                  label: "Peran",
                  class: "caption black--text my-0 py-0"
                }
              ],
              custom: true
            },
            {
              grid: { cols: 12, sm: 12, md: 3, lg: 3, xl: 3 },
              content: [
                {
                  label: "Instansi",
                  name: "k_admin_bgp",
                  class: "caption black--text my-0 py-0"
                }
              ],
              customWilayah: true
            }
          ]
        }
      ];
      return conf;
    },
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    }
  },
  activated() {
    this.load();
  },
  methods: {
    toDashboard() {
      this.$router.push({ name: "instansi.pilih.admin" });
    },
    load() {
      var params = {
        page: this.cp,
        peran: this.peran
      };
      if (this.dataPencarian) {
        var param = this.dataPencarian.param.value == "surel" ? "email" : this.dataPencarian.param.value;
        params[param] = this.dataPencarian.s;
      }
      return this.$store
        .dispatch("user/getPengelola", {
          instansi_id: this.instansi_id,
          params: params
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    ajukan(item) {
      this.$confirm(
        `Apakah Anda yakin akan mempublikasikan Anggota ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.judul} <br>
        </div>
      `
      )
        .then(() =>
          this.$store
            .dispatch("user/ajukan", { obj: item })
            .then(() => {
              this.$info("Data berhasil diajukan");
            })
            .then(() => this.load())
            .catch(e => e)
        )
        .catch(e => e);
    },
    setRole(item) {
      this.$confirm(
        `Apakah Anda yakin akan mengubah peran pengguna sesuai data yang Anda pilih?<br>
        <div class='mt-2 title font-weight-bold text-center red--text text--darken-2'>
          ${item.name}
        </div>
        `,
        {
          role: [
            { id: 2, name: "Kontributor" },
            { id: 3, name: "Kurator" }
          ],
          mapel: this.itemMapels
        },
        "Ubah Peran",
        item
      )
        .then(res => {
          var obj = {
            user_id: item.id,
            role_id: typeof res.role == "object" ? res.role.id : res.role,
            mapel: res.mapel
            // is_simpatika:
            //   typeof res.tenant === "object" ? res.tenant.id : res.tenant
          };
          this.$store
            .dispatch("user/setRole", obj)
            .then(() => {
              this.load();
              this.$info("Ubah peran user berhasil");
            })
            .catch(e => e);
        })
        .catch(e => e);
    },
    detail(item) {
      this.$refs.detailDlg.open(item);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    link(item) {
      window.open(item.link, "_blank");
    },
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus user ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.name}<br>
        </div>`,
        {
          cancelOnly: item.laporan_accepted_count > 0 ? true : false
        }
      )
        .then(() => this.$store.dispatch("user/drop", item))
        .then(() => {
          this.$info("User " + item.name + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    wrapObj(path, obj) {
      var context = obj || this;
      path = path.split(".");

      for (var i = 0; i < path.length; i++) {
        context = context[path[i]];
      }

      return context;
    }
  },
  watch: {}
};
</script>
